// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5c-0";
export var startPickingButton = "_5c-1";